import { render } from "./dateTime.vue?vue&type=template&id=1495548c&ts=true"
import script from "./dateTime.vue?vue&type=script&lang=tsx"
export * from "./dateTime.vue?vue&type=script&lang=tsx"

import "./dateTime.vue?vue&type=style&index=0&id=1495548c&lang=less"

import exportComponent from "C:\\code\\webapp\\postcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__